import { create } from 'zustand';

type StockPerformance = {
    name: string;
    symbol: string;
    percentage: number;
};

type StockPerformanceState = {
    bestPerforming: StockPerformance | null;
    worstPerforming: StockPerformance | null;
    setBestPerforming: (stock: StockPerformance | null) => void; // Allow null
    setWorstPerforming: (stock: StockPerformance | null) => void; // Allow null
};

export const useStockPerformanceStore = create<StockPerformanceState>((set) => ({
    bestPerforming: null,
    worstPerforming: null,
    setBestPerforming: (stock) => set({ bestPerforming: stock }), // No type error now
    setWorstPerforming: (stock) => set({ worstPerforming: stock }), // No type error now
}));
